<template>
  <van-collapse v-model="activeNames">
    <van-collapse-item class="r-1" title="动产抵押登记信息" name="1">
      <van-cell-group>
        <van-field
          readonly
          :value="data.pledge.registNo"
          label="登记编号"
          placeholder="无"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          readonly
          :value="data.pledge.registOffice"
          label="登记机关"
          placeholder="无"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          readonly
          :value="data.pledge.registDate"
          label="登记时间"
          placeholder="无"
        />
      </van-cell-group>
    </van-collapse-item>
    <van-collapse-item title="抵押权人" name="2">
      <div
        class="item coll2 comWrapper card mt-2 mb-2 p-3"
        v-for="(item, index) in data.pledgeeList"
        :key="index"
      >
        <div class="comWrapper-wrapper van-hairline--bottom">
          <span></span>
          {{ item[pledgeListCol[0].field] }}
        </div>
        <van-cell-group>
          <template v-for="(col, idx) in pledgeListCol">
            <van-cell
              v-if="idx > 0"
              :key="'col_' + idx"
              :title="col.title"
              :value="item[col.field]"
            />
          </template>
        </van-cell-group>
      </div>
    </van-collapse-item>
    <van-collapse-item class="r-1 coll3" title="被担保债权概况" name="3">
      <van-cell-group>
        <van-field
          readonly
          :value="data.securedClaim.kind"
          label="种类"
          placeholder="无"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          readonly
          :value="data.securedClaim.amount"
          label="数额"
          placeholder="无"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          readonly
          :value="data.securedClaim.fulfillObligation"
          label="债务人履行债务的期限"
          placeholder="无"
        />
      </van-cell-group>
    </van-collapse-item>
    <van-collapse-item v-if="data.guaranteeList && data.guaranteeList.length>0" title="抵押物信息" name="4">
      <div
        class="item coll2 comWrapper card mt-2 mb-2 p-3"
        v-for="(item, index) in data.guaranteeList"
        :key="index"
      >
        <div class="comWrapper-wrapper van-hairline--bottom">
          <span></span>
          {{ item[guaranteeListCol[0].field] }}
        </div>
        <van-cell-group>
          <template v-for="(col, idx) in guaranteeListCol">
            <van-cell
              v-if="idx > 0 && col.field != 'keyNoList'"
              :key="'col_' + idx"
              :title="col.title"
              :value="item[col.field]"
            />
            <van-cell
              v-if="idx > 0 && col.field == 'keyNoList'"
              :key="'col_' + idx"
            >
              <template #title>
                {{ col.title }}
              </template>
              <template #extra>
                <div class="van-cell__value">
                  <div
                    v-for="(last, index) in item[col.field]"
                    :key="'last_' + index"
                  >
                    <span v-text="last.name"></span>
                  </div>
                </div>
              </template>
            </van-cell>
          </template>
        </van-cell-group>
      </div>
    </van-collapse-item>
    <van-collapse-item v-if="data.cancelInfo" class="r-1 coll3" title="动产抵押登记注销信息" name="5">
      <van-cell-group>
        <van-field
          readonly
          :value="data.cancelInfo.cancelDate"
          label="动产抵押登记注销时间"
          placeholder="无"
        />
      </van-cell-group>
      <van-cell-group>
        <van-field
          readonly
          :value="data.cancelInfo.cancelReason"
          label="动产抵押登记注销原因"
          placeholder="无"
        />
      </van-cell-group>
    </van-collapse-item>
    <van-collapse-item v-if="data.changeList && data.changeList.length>0" title="动产抵押登记变更信息" name="6">
      <div
        class="item coll2 comWrapper card mt-2 mb-2 p-3"
        v-for="(item, index) in data.changeList"
        :key="index"
      >
        <div class="comWrapper-wrapper van-hairline--bottom">
          <span></span>
          {{ item[changeListCol[0].field] }}
        </div>
        <van-cell-group>
          <template v-for="(col, idx) in changeListCol">
            <van-cell
              v-if="idx > 0"
              :key="'col_' + idx"
              :title="col.title"
              :value="item[col.field]"
            />
          </template>
        </van-cell-group>
      </div>
    </van-collapse-item>
  </van-collapse>
</template>

<script>
export default {
  data() {
    return {
      activeNames: ["1", "2", "3", "4", "5", "6"],
      data: {
        pledge: {
          registNo: "",
          registOffice: "",
          registDate: "",
        },
        pledgeeList: [],
        securedClaim: {
          kind: "",
          amount: "",
          assuranceScope: "",
          fulfillObligation: "",
          remark: "",
        },
        guaranteeList: [],
        cancelInfo: {
          cancelDate: "",
          cancelReason: "",
        },
        changeList: [],
      },
      pledgeListCol: [
        { title: "名称", field: "name" },
        { title: "抵押权人证照类型", field: "identityType" },
        { title: "证件号码", field: "identityNo" },
      ],
      guaranteeListCol: [
        { title: "名称", field: "name" },
        { title: "所有权或使用权归属", field: "ownership" },
        { title: "数量、质量、状况、所在地等情况", field: "other" },
        { title: "备注", field: "remark" },
        { title: "所有权或使用权归属信息", field: "keyNoList" },
      ],
      changeListCol: [
        { title: "动产抵押登记变更日期", field: "changeDate" },
        { title: "动产抵押登记变更内容", field: "changeContent" },
      ],
    };
  },
  created() {
    let obj = localStorage.getItem("risk_detail_data");
    try {
      obj = JSON.parse(obj);
      if (obj != null) this.data = obj;
    } catch (e) {}
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/mixin.scss";
@import "./style.scss";
.r-1 /deep/ .van-collapse-item__content {
  padding: 0px 16px;
}
.coll2 .van-cell__value {
  flex: 1;
  margin-left: 8px;
}
.coll2 .van-cell {
  padding: 10px 0;
}
.coll3 /deep/ .van-field__label {
  flex: 1;
}
</style>